import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "./apiClient";

/* ──────────────── helpers ──────────────── */
function toFormData(obj) {
  const fd = new FormData();
  Object.entries(obj).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    fd.append(k, v);
  });
  return fd;
}

/* ──────────────── thunks ──────────────── */
export const fetchEvents = createAsyncThunk("events/fetchAll", async (_, { rejectWithValue }) => {
  try {
    const res = await apiClient.get("/events/");
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const insertEvent = createAsyncThunk("events/insert", async (payload, { rejectWithValue }) => {
  try {
    const res = await apiClient.post("/events/", toFormData(payload), {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const updateEvent = createAsyncThunk("events/update", async (payload, { rejectWithValue }) => {
  try {
    const res = await apiClient.put(`/events/${payload.id}/`, toFormData(payload), {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const deleteEvent = createAsyncThunk("events/delete", async (id, { rejectWithValue }) => {
  try {
    await apiClient.delete(`/events/${id}/`);
    return id;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

/* ──────────────── slice ──────────────── */
const eventsSlice = createSlice({
  name: "events",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchEvents.pending, (s) => {
      s.loading = true;
      s.error = null;
    });
    b.addCase(fetchEvents.fulfilled, (s, a) => {
      s.loading = false;
      s.items = a.payload;
    });
    b.addCase(fetchEvents.rejected, (s, a) => {
      s.loading = false;
      s.error = a.payload;
    });

    b.addCase(insertEvent.fulfilled, (s, a) => {
      s.items.push(a.payload);
    });

    b.addCase(updateEvent.fulfilled, (s, a) => {
      const i = s.items.findIndex((e) => e.id === a.payload.id);
      if (i !== -1) s.items[i] = a.payload;
    });

    b.addCase(deleteEvent.fulfilled, (s, a) => {
      s.items = s.items.filter((e) => e.id !== a.payload);
    });
  },
});

export default eventsSlice.reducer;
